// extracted by mini-css-extract-plugin
export default {"title":"_1yJY-___Buildings-module__title","cardList":"_1LOda___Buildings-module__cardList"};